import { jsx as _jsx } from "react/jsx-runtime";
import { makeStyles, Badge as MuiBadge } from '@material-ui/core';
import { CheckCircleOutlineOutlined, ReportProblemOutlined } from '@material-ui/icons';
import clsx from 'clsx';
import { pxToRem } from '../../../../theme';
const useStyles = makeStyles((theme) => ({
    badge: {
        backgroundColor: theme.palette.primary.main,
        borderRadius: '50%',
        display: 'flex',
        fontSize: pxToRem(12),
        fontWeight: 500,
        height: 20,
        margin: theme.spacing(0, 1.25, 0, 0),
        width: 20,
        '&[data-variant="dot"]': {
            height: 10,
            minWidth: 10,
            padding: 0,
        },
    },
    checkCircle: {
        background: 'none',
        margin: 0,
        '& path': {
            fill: theme.palette.success.main,
        },
    },
    dot: {
        backgroundColor: theme.palette.primary.main,
        height: 8,
        margin: theme.spacing(0, 1.5, 0, 0),
        padding: 0,
        width: 8,
    },
    warningOutlined: {
        background: 'none',
        margin: 0,
        '& path': {
            fill: theme.palette.warning.main,
        },
    },
}));
/**
 * Badge component used for status display.
 *
 * @param shouldShowDot - Determines whether to show a dot or not.
 * @param status - The status of the badge.
 * @returns The rendered `Badge` component.
 */
export function Badge({ shouldShowDot = false, status }) {
    const classes = useStyles();
    const badgeVariant = shouldShowDot ? 'dot' : 'standard';
    const badgeContent = shouldShowDot ? null : status;
    if (status === 'success' && !shouldShowDot) {
        return (_jsx(CheckCircleOutlineOutlined, { className: clsx(classes.badge, classes.checkCircle), "data-testid": 'success-icon', fontSize: 'small' }));
    }
    if (status === 'warning' && !shouldShowDot) {
        return (_jsx(ReportProblemOutlined, { className: clsx(classes.badge, classes.warningOutlined), "data-testid": 'warning-icon', fontSize: 'small' }));
    }
    return (_jsx(MuiBadge, { anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
        }, badgeContent: badgeContent, classes: {
            badge: classes.badge,
            dot: classes.dot,
        }, color: 'primary', "data-testid": 'notification-icon', overlap: 'circle', variant: badgeVariant }));
}
